module.exports = __webpack_public_path__ + "static/media/approve.5830a946.svg";